import {
  assign, createMachine, DoneInvokeEvent, sendParent,
} from 'xstate';
import {
  InitialState, EVENTS, ACTIONS, TAKE_TYPES, ITakeObj,
} from '../../interfaces/storageInterface';
import { EVENTS as WIDGET_EVENTS } from '../../interfaces/widgetInterface';

export const storageMachine = createMachine<InitialState, DoneInvokeEvent<any>>({
  predictableActionArguments: true,
  id: 'storage',
  context: {
    questions: {},
    practice: {},
  },
  on: {
    [EVENTS.STORE_TAKE]: {
      actions: [ACTIONS.STORE_TAKE],
    },
    [EVENTS.GET_TAKE]: {
      actions: [ACTIONS.SEND_TAKE],
    },
    [EVENTS.GET_TAKES]: {
      actions: [ACTIONS.SEND_TAKES],
    },
    [EVENTS.REMOVE_TAKES]: {
      actions: [ACTIONS.REMOVE_TAKES],
    },
  },
}, {
  actions: {
    [ACTIONS.CONSOLE_LOG]: (context, event) => console.log('Storage Machine', context, event),
    [ACTIONS.STORE_TAKE]: assign((context, event) => {
      const { takeType, currentQuestion = 0, take, videoLength } = event.data;
      const objectToSave = {
        file: take,
        objectUrl: URL.createObjectURL(take),
        videoLength,
      };
      const fieldName = takeType === TAKE_TYPES.QUESTION ? 'questions' : 'practice';
      return {
        [fieldName]: {
          ...context[fieldName],
          [currentQuestion]: (context[fieldName][currentQuestion] || []).concat(objectToSave),
        },
      };
    }),
    [ACTIONS.SEND_TAKE]: sendParent((context, { data }) => ({
      type: WIDGET_EVENTS.TAKE_TO_UPLOAD_RECEIVED,
      data: {
        file: context.questions[data.currentQuestion][data.selectedTake - 1].file,
        videoLength: context.questions[data.currentQuestion][data.selectedTake - 1].videoLength,
        selectedTake: data.selectedTake,
      },
    })),
    [ACTIONS.SEND_TAKES]: sendParent((context, event) => {
      const { takeType, currentQuestion = 0 } = event.data;
      const fieldName = takeType === TAKE_TYPES.QUESTION ? 'questions' : 'practice';
      return { type: WIDGET_EVENTS.TAKES_RECEIVED, data: context[fieldName][currentQuestion].map((object) => object.objectUrl) };
    }),
    [ACTIONS.REMOVE_TAKES]: assign((context, event) => {
      const { questionToRemove } = event.data;
      Object.values(context.practice).forEach((takes) => takes.forEach((takeObj: ITakeObj) => URL.revokeObjectURL(takeObj.objectUrl)));
      context.questions[questionToRemove]?.forEach((takeObj) => URL.revokeObjectURL(takeObj.objectUrl));

      return {
        questions: Object.entries(context.questions).reduce((acc, [key, val]) => ({ ...acc, [key]: Number(key) === questionToRemove ? [] : val }), {}),
        practice: {},
      };
    }),
  },
});
